import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FieldValue } from '../../../../../@core/models/site-material-data.model';


@Component({
    selector: 'app-material-radiobutton',
    templateUrl: './radiobutton.component.html',
    styleUrls: ['./radiobutton.component.scss']
})

export class MaterialRadiobuttonComponent {
    @Input() positionField: number = undefined;
    @Input() field: number = undefined;
    @Input() options: string [];
    @Input() onBuilder: string = '';
    @Output() setValueEvent = new EventEmitter<FieldValue>();
    value: string = '';
    errorMessage: string = '';
    constructor() {}

    radiobuttonValidator($event) {
        this.setValueEvent.emit({type: 'radiobutton', value: $event.value, required: false, position: this.field});
    }
}
